import { useMutation, useQueryClient } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementAssignmentQueryKey } from '../queryKeys';
import { refetchChangedQueries } from './refetchChangedQueries';
import { CustomerAgreementAssignment, CustomerAgreementCustomer } from '../types';

export type AssignCustomerAgreement = (
    customer: CustomerAgreementCustomer,
    customerAgreementId: number | null
) => Promise<CustomerAgreementAssignment>;

type AssignVariables = { customer: CustomerAgreementCustomer; customerAgreementId: number | null };

export function useAssignCustomerAgreementMutation(): AssignCustomerAgreement {
    const queryClient = useQueryClient();

    const mutation = useMutation<CustomerAgreementAssignment, unknown, AssignVariables>(
        ({ customer, customerAgreementId }) =>
            CustomerAgreementsApi.assign(customer, customerAgreementId),
        {
            onSuccess: () =>
                refetchChangedQueries(queryClient, [[CustomerAgreementAssignmentQueryKey]])
        }
    );

    return function assignCustomerAgreement(
        customer: CustomerAgreementCustomer,
        customerAgreementId: number | null
    ) {
        return mutation.mutateAsync({ customer, customerAgreementId });
    };
}
